import { initialDoctorsState } from 'redux/initialState';
import { status } from 'constants/general';

import doctorsActionTypes from './action-types';

const doctorsReducer = (state = initialDoctorsState, { type, payload }) => {
  switch (type) {
    case doctorsActionTypes.FETCH_DOCTORS_LIST:
      return {
        ...state,
        doctorsList: {
          status: status.FETCHING,
        },
      };

    case doctorsActionTypes.FETCH_DOCTORS_LIST_SUCCESS:
      return {
        ...state,
        doctorsList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case doctorsActionTypes.FETCH_DOCTORS_LIST_FAIL:
      return {
        ...state,
        doctorsList: {
          status: status.FAIL,
        },
      };

    case doctorsActionTypes.FETCH_UPDATE_DOCTOR_LICENCE_STATUS:
      return {
        ...state,
        updateDoctorLicenceStatus: {
          status: status.FETCHING,
        },
      };

    case doctorsActionTypes.FETCH_UPDATE_DOCTOR_LICENCE_STATUS_SUCCESS:
      return {
        ...state,
        updateDoctorLicenceStatus: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case doctorsActionTypes.FETCH_UPDATE_DOCTOR_LICENCE_STATUS_FAIL:
      return {
        ...state,
        updateDoctorLicenceStatus: {
          status: status.FAIL,
        },
      };

    case doctorsActionTypes.FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES:
      return {
        ...state,
        assignOrRevokeDoctorBadges: {
          status: status.FETCHING,
        },
      };

    case doctorsActionTypes.FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES_SUCCESS:
      return {
        ...state,
        assignOrRevokeDoctorBadges: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case doctorsActionTypes.FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES_FAIL:
      return {
        ...state,
        assignOrRevokeDoctorBadges: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default doctorsReducer;
